import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ignore-certificate',
  templateUrl: './ignore-certificate.component.html'
})
export class IgnoreCertificateComponent{

  constructor(private dialog: MatDialogRef <IgnoreCertificateComponent>,
    public service: IdexService,  private toast: Toast,private translate: TranslateService) { 
     
    }
  
  openPersonalCert(){
    const obj = {
      id: -1
   };
    this.service.post('cert/save', obj)
    .subscribe(data => {
      if (data) {
          this.onAlert('alert.save_complete');
          this.dialog.close();
          window.location.reload();
      }
    }); 
  }

  onAlert(text: string) {
    this.translate.get(text).subscribe(s => {
       this.toast.success(s);
    });
 }

}